
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class NewPatientCenter extends Vue {
  get rawChartData(): any[] {
    return dataVisualizationModule.getChartData("newPatientCenterCount");
  }

  get newPatients(): number {
    return this.rawChartData[0]?.NewPatientsInLastYearCount || 0;
  }

  get totalPatients(): number {
    return this.rawChartData[0]?.TotalPatientsCount || 0;
  }

  get totalCenters(): number {
    return this.rawChartData[0]?.TotalCentersCount || 0;
  }

  get newCenters(): number {
    return this.rawChartData[0]?.NewCentersCount || 0;
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("newPatientCenterCount");
    } catch (error) {
      console.error("Failed to load data", error);
    }
  }
}
